Drupal.behaviors.nodeTrackingBehaviour = {
  attach: function (context, settings) {
    let article_header_info = once(
      "nodeTracking",
      ".node-tracking-item",
      context
    );

    article_header_info.forEach((header) => {
      let site_id = header.dataset.siteId;
      let node_id = header.dataset.nodeId;

      if (site_id) {
        fetch("https://musudiena.lt/track-view/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            article_id: node_id,
            portal_id: site_id,
          }),
        });
      }
    });
  },
};
